/**
 * Build markers on OpenStreetMap for multiple maps with multiple markers on a page.
 * HTML structure:
 * <div id="map-{data.uid}" class="osm-map" 
 *      data-zoom="14" 
 *      data-markers='[{"lat": "55.6799778", "lng": "12.540554585000528", "campus": "Frederiksberg Campus", "address": ""}]'
 * ></div>
 */

document.addEventListener('DOMContentLoaded', function () {
    if (typeof pageLanguage !== 'function') {
        return;
    }

    /**
     * Translation object for popup links.
     * Danish translation with English fallback.
     * @type {Object}
     */
    const translations = {
        large_map: {
            da: 'Vis stort kort',
            en: 'View large map'
        }
    };

    /**
     * Detect current page language using global function.
     * Defaults to 'en' if not set or unsupported.
     * @type {string}
     */
    const currentLang = pageLanguage();

    // Make map text label
    const largeMapLabel = translations.large_map[currentLang] || translations.large_map.en;

    /**
     * Select all map containers on the page.
     * @type {NodeListOf<HTMLElement>}
     */
    const mapEls = document.querySelectorAll('.osm-map');

    /**
     * Initialize each map container with markers.
     */
    mapEls.forEach((el) => {
        const zoom = parseInt(el.dataset.zoom, 10) || 10;
        const markers = JSON.parse(el.dataset.markers);

        /**
         * Initialize Leaflet map instance.
         * @type {L.Map}
         */
        const map = L.map(el.id, { attributionControl: true })
            .setView([55.6764406, 12.5682006], zoom);

        // Add OpenStreetMap tiles
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(map);

        /**
         * Feature group to hold all markers for this map.
         * @type {L.FeatureGroup}
         */
        const markerGroup = L.featureGroup();
        let firstLatLng = null;

        /**
         * Loop through all markers for this map and add them.
         */
        markers.forEach((m, index) => {
            if (m.lat && m.lng) {
                const marker = L.marker([m.lat, m.lng]);

                /**
                 * Build popup content string for the marker.
                 * @type {string}
                 */
                let popupContent = '';

                if (m.campus) {
                    popupContent += `<strong>${m.campus}</strong><br>`;
                }

                if (m.address) {
                    popupContent += m.address;
                }

                if (popupContent) {
                    const largeMapLabel = translations.large_map[currentLang] || translations.large_map.en;

                    const link = `https://www.openstreetmap.org/?mlat=${m.lat}&mlon=${m.lng}`+`#map=${zoom}/${m.lat}/${m.lng}`;

                    popupContent += `<p><a href="${link}" rel="noopener noreferrer" data-category-content-presentation="${largeMapLabel}" data-category-content-name="${m.campus}">${largeMapLabel}</a></p>`;

                    marker.bindPopup(popupContent);
                }

                markerGroup.addLayer(marker);

                if (index === 0) {
                    firstLatLng = [m.lat, m.lng];
                }
            }
        });
        // Add all markers to the map
        markerGroup.addTo(map);

        // Fit map bounds if more than one marker
        if (markerGroup.getLayers().length > 1) {
            map.fitBounds(markerGroup.getBounds(), { maxZoom: zoom });
        }

        // Center map on the first marker
        if (firstLatLng) {
            map.setView(firstLatLng, zoom);
        }
    });
});